var map = {
	"./alert-icon.svg": "dd45",
	"./bank-icon.svg": "69d2",
	"./broken-link-icon.svg": "27f8",
	"./check-green-icon.svg": "397b",
	"./credit-card-icon.svg": "ceab",
	"./discount-icon.svg": "c2ab",
	"./heart-icon.svg": "267f",
	"./question-mark-icon.svg": "2749",
	"./success-icon.svg": "13a1",
	"./warning-icon.svg": "209f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "07bc";